// @ts-check

import { createStore } from "redux";
import rootReducer from "./reducers";
import * as localStorageConnector from './localStorageConnector'

const persistedState = localStorageConnector.loadState();
const store = createStore(
  rootReducer,
  persistedState || {},
  // @ts-ignore
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

///// If needed throttle this to increase performence
// import throttle from 'lodash.throttle';
// ...
// store.subscribe(throttle(() => {
//   saveState({
//     todos: store.getState().todos
//   });
// }, 1000));

store.subscribe(() => {
  /** @type {any} */
  const state = store.getState()
  localStorageConnector.saveState(state);
  // console.log('my log', state)
});

export default store
